import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const valueTypeIcons = {
    none: /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "hide"
            }),
            /*#__PURE__*/ _jsxs("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        fill: "currentColor",
                        d: "M14.6,5.6l-8.2,8.2C6.9,13.9,7.5,14,8,14c3.6,0,6.4-3.1,7.6-4.9c0.5-0.7,0.5-1.6,0-2.3 C15.4,6.5,15,6.1,14.6,5.6z"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("path", {
                        fill: "currentColor",
                        d: "M14.3,0.3L11.6,3C10.5,2.4,9.3,2,8,2C4.4,2,1.6,5.1,0.4,6.9c-0.5,0.7-0.5,1.6,0,2.2c0.5,0.8,1.4,1.8,2.4,2.7 l-2.5,2.5c-0.4,0.4-0.4,1,0,1.4C0.5,15.9,0.7,16,1,16s0.5-0.1,0.7-0.3l14-14c0.4-0.4,0.4-1,0-1.4S14.7-0.1,14.3,0.3z M5.3,9.3 C5.1,8.9,5,8.5,5,8c0-1.7,1.3-3,3-3c0.5,0,0.9,0.1,1.3,0.3L5.3,9.3z"
                    })
                ]
            })
        ]
    }),
    flex: /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "distribute-horizontal"
            }),
            /*#__PURE__*/ _jsxs("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ _jsx("rect", {
                        x: "6",
                        y: "3",
                        fill: "currentColor",
                        width: "4",
                        height: "10"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("rect", {
                        "data-color": "color-2",
                        width: "2",
                        height: "16"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("rect", {
                        "data-color": "color-2",
                        x: "14",
                        width: "2",
                        height: "16"
                    })
                ]
            })
        ]
    }),
    block: /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "divider"
            }),
            /*#__PURE__*/ _jsxs("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        fill: "currentColor",
                        d: "M1,1v3c0,0.552,0.448,1,1,1h12c0.552,0,1-0.448,1-1V1c0-0.552-0.448-1-1-1H2C1.448,0,1,0.448,1,1z"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("path", {
                        fill: "currentColor",
                        d: "M1,12v3c0,0.552,0.448,1,1,1h12c0.552,0,1-0.448,1-1v-3c0-0.552-0.448-1-1-1H2C1.448,11,1,11.448,1,12z"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("path", {
                        "data-color": "color-2",
                        d: "M15,9H1C0.448,9,0,8.552,0,8v0c0-0.552,0.448-1,1-1h14c0.552,0,1,0.448,1,1v0 C16,8.552,15.552,9,15,9z"
                    })
                ]
            })
        ]
    }),
    inline: /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "edit-2"
            }),
            /*#__PURE__*/ _jsx("g", {
                fill: "currentColor",
                children: /*#__PURE__*/ _jsx("path", {
                    fill: "currentColor",
                    d: "M8,0H1v4h1l0.72361-1.44721C2.893,2.214,3.23926,2,3.61803,2H7v11.27924 c0,0.43043-0.27543,0.81257-0.68377,0.94868L4,15v1h4h4v-1l-2.31623-0.77208C9.27543,14.09181,9,13.70967,9,13.27924V2h3.38197 c0.37877,0,0.72504,0.214,0.89443,0.55279L14,4h1V0H8z"
                })
            })
        ]
    }),
    "inline-block": /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "scale-horizontal"
            }),
            /*#__PURE__*/ _jsxs("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ _jsx("polygon", {
                        "data-color": "color-2",
                        points: "16,13 13,10 13,12 3,12 3,10 0,13 3,16 3,14 13,14 13,16 "
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("polygon", {
                        fill: "currentColor",
                        points: "8,0 3,0 3,4 4,4 5,2 7,2 7,8 5,9 5,10 8,10 11,10 11,9 9,8 9,2 11,2 12,4 13,4 13,0 "
                    })
                ]
            })
        ]
    })
};
